// extracted by mini-css-extract-plugin
export var dividerLine = "_52-3";
export var itemImage = "_52-9";
export var lightDivider = "_52-4";
export var modalContent = "_52-5";
export var modalContentCompact = "_52-6";
export var productCard = "_52-a";
export var productImage = "_52-b";
export var productImageCompact = "_52-7";
export var productImagePlaceholder = "_52-c";
export var productImagePlaceholderCompact = "_52-8";
export var progressBarBackground = "_52-1";
export var progressBarContainer = "_52-0";
export var progressBarFill = "_52-2";